<app-image-loader
    src="assets/img/{{ paymentMethodName | imgType | async }}.svg"
    [alt]="alt ? alt : paymentMethodName + '-logo'"
    [title]="title ? title : paymentMethodName + '-logo'"
    [width]="width"
    [height]="height"
/>
